import { render, staticRenderFns } from "./EbnormalEnergy.vue?vue&type=template&id=15bcace8&scoped=true"
import script from "./EbnormalEnergy.vue?vue&type=script&lang=js"
export * from "./EbnormalEnergy.vue?vue&type=script&lang=js"
import style0 from "./EbnormalEnergy.vue?vue&type=style&index=0&id=15bcace8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bcace8",
  null
  
)

export default component.exports